import { render } from "./ClipArt.vue?vue&type=template&id=5de72e0a&ts=true"
import script from "./ClipArt.vue?vue&type=script&lang=ts"
export * from "./ClipArt.vue?vue&type=script&lang=ts"

import "./ClipArt.vue?vue&type=style&index=0&id=5de72e0a&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__